import React, { useEffect } from "react";
import { InlineTextField } from "components/forms/FormFields/InlineTextField";
import appTheme from "style/theme";
import { TextFieldProps } from "components/forms/TextField";

const InAppLinkInput = ({
  value,
  fieldName,
  getTextFieldProps,
  onChange,
}: {
  value: string;
  fieldName: string;
  getTextFieldProps: (field: string, errorId?: string) => TextFieldProps;
  onChange: (selectedField: any, selectedValue: any) => void;
}) => {
  useEffect(() => {
    onChange(fieldName, value);
  }, []);

  return (
    <InlineTextField
      {...getTextFieldProps(fieldName)}
      width={appTheme.forms.full}
      value={value}
    />
  );
};

export default InAppLinkInput;
